import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { BinderSessionWizardService } from '../../services/sections/binder/binder-session-wizard.service';
import { catchError, map } from 'rxjs/operators';
import { GlobalSettingsService } from '../../services/ui/global-settings.service';
import { Observable, of } from 'rxjs';
import {BinderSessionStatus} from '../../models/binder/binder-session-confirmation-response.model';

@Injectable({
	providedIn: 'root',
})
export class BinderSessionStatusResolver implements Resolve<BinderSessionStatus> {
	constructor(
		private router: Router,
		private binderSessionWizardService: BinderSessionWizardService,
	) {}

	resolve(route: ActivatedRouteSnapshot): Observable<BinderSessionStatus> {
		GlobalSettingsService.isGlobalLoaderLoading = true;
		GlobalSettingsService.isSecondaryLoaderLoading = true;

		const token = route.paramMap.get('token');
		if (!token) {
			this.router.navigate(['/404']);
			return of(null);
		}

		return this.binderSessionWizardService.status(token).pipe(
			map(response => {
				if (response) {
					return response;
				} else {
					this.router.navigate(['/404']);
					return null;
				}
			}),
			catchError(() => {
				this.router.navigate(['/404']);
				return of(null);
			})
		);

	}
}
